module.exports = __webpack_public_path__ + "static/media/risk-assesment.35926d51.png";